import React from 'react'
import Icon from 'decorators/Icon'

// eslint-disable-next-line react/prop-types
const IconPaypal = ({ t, fill, className, height, width }) => (
  <svg
    width={width}
    height={height}
    className={className}
    viewBox='0 0 39 39'
    xmlnsXlink='http://www.w3.org/1999/xlink'>
    <title>{t('Paypal')}</title>
    <g transform='translate(-2)'>
      <path fill='#0092D9' d='M32.067 12.77c-1.387 5.779-5.75 7.648-11.5 7.648h-2.974c-.595 0-1.19.51-1.388 1.02l-1.983 10.367c0 .34.199.68.793.68h5.156c.595 0 1.19-.34 1.19-.85v-.17l.99-5.269v-.34c0-.51.596-.85 1.19-.85h.794c4.957 0 8.923-1.699 9.914-6.797.396-2.04.199-3.91-.991-5.1-.199-.34-.595-.68-1.191-.85v.51z' />
      <path fill='#002A7B' d='M23.268 5h-9.914c-.596 0-1.19.51-1.388 1.02L8 28.284c0 .51.397.85.793.85h6.146l1.587-8.328v.34c.198-.51.793-1.02 1.388-1.02h2.975c5.75 0 10.111-2.04 11.5-7.648v-.51c.198-2.209-.2-3.569-1.586-4.929C29.415 5.68 26.837 5 23.268 5z' />
      <path fill='#021E5E' d='M30.573 11.733c-.198 0-.397-.17-.595-.17-.199 0-.397 0-.594-.17-.794-.17-1.587-.17-2.578-.17h-7.734c-.198 0-.397 0-.595.17-.396.17-.594.51-.594.849l-1.587 8.838v.34c.199-.51.793-1.02 1.388-1.02h2.975c5.75 0 10.111-2.039 11.5-7.648 0-.17 0-.34.198-.51-.397-.169-.594-.34-.991-.34-.596-.17-.596-.17-.793-.17' />
    </g>
  </svg>
)

export default Icon(IconPaypal)
